type GetCountValueParams = {
    isDataLoaded: boolean;
    isLoading: boolean;
    topicCount: number | undefined;
    translate: (key: string) => string;
};

export const getCountValue = ({
    isDataLoaded,
    isLoading,
    topicCount,
    translate,
}: GetCountValueParams): string | number => {
    if (isLoading) {
        return "...";
    }

    if (!isDataLoaded) {
        return translate("common.n/a");
    }

    return topicCount ?? 0;
};
